// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"204":"880ec7c4","278":"cbb8b248","396":"39f431d5","532":"fbce731c","889":"3492f5e0","956":"6dcc79ee"}[chunkId] + ".chunk.css";
};